import { createBaseTransport, createXResolveProvider, TransportEvent } from '@spotify-internal/transport';

const getTokenProvider = async (): Promise<[string, number]> => {
  if (typeof window !== 'undefined') {
    return await (await import('utils/client/auth/auth')).getWebApiToken();
  }
  return new Promise<any>((_, reject) => reject('auth lib only works in browser'));
};

const getEndpoints = () => {
  if (typeof window !== 'undefined') {
    return createXResolveProvider();
  }

  // Fallback
  return async () => ({
    webgate: 'https://generic.wg.spotify.com',
    webapi: 'https://api.spotify.com',
  });
};

// https://backstage.spotify.net/docs/js-sdk-transport/manual/instantiating/#creating-transport-instances
export const transport = createBaseTransport({
  ownerRef: {},
  providers: {
    endpoints: getEndpoints(),
    token: getTokenProvider,
  },
  disconnectBeforeUnload: true,
});

// https://backstage.spotify.net/docs/js-sdk-transport/manual/lifecycle/#authentication
transport.on(TransportEvent.CONNECTED, () => {
  // Authenticate after connection
  if (typeof window !== 'undefined') {
    transport.authenticate().catch(error => {
      if (error.message === 'logged out') return; // ignore when logged out
      if (process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line no-console
        console.error('TOKEN ERROR', error.message); // TODO: Switch to sentry.captureException
      }
    });
  }
});

if (process.env.NODE_ENV !== 'test') {
  // Connect in non-blocking fashion
  transport.connect();
}
